/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { useTranslation } from 'react-i18next'
import { useModal } from '../../contexts/ModalContext'
import Modal from '../Modal'
import WorkflowDetailsModal from './WorkflowDetailsModal'
import type { Workflow } from '../../services/api/types'

interface MultipleWorkflowsModalProps {
  workflow: Workflow[]
  onClose: () => void
}

export function MultipleWorkflowsModal({ workflow, onClose }: MultipleWorkflowsModalProps) {
  const { t } = useTranslation()
  const { showModal } = useModal()

  const save = () => {
    onClose()
  }

  const dismiss = () => {
    onClose()
  }

  const goToModal = (modalName: string, workflowId: number) => {
    if (modalName === 'WorkflowDetailModal') {
      showModal(<WorkflowDetailsModal wfId={workflowId} onClose={() => {}} />, {
        keepParentModalsOpen: true
      })
    }
  }

  return (
    <Modal show={true} handleClose={dismiss} title={t('WORKFLOWS_TITLE')} size="sm" id="modal-add-file">
      <Modal.Body>
        <div className="form-group md-form-group wparag w100p">
          <label>{t('WORKFLOWS_TITLE')}</label>
          <p>
            {workflow.length > 1 &&
              workflow.map((wf, index) => (
                <span key={wf.id || index}>
                  <a
                    className="form-group md-form-group w100p cursor-pointer"
                    onClick={() => goToModal('WorkflowDetailModal', wf.id)}
                  >
                    {wf.formattedId}
                  </a>
                </span>
              ))}
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button className="btn btn-primary" type="button" onClick={save}>
          {t('OK')}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default MultipleWorkflowsModal
